import { fetcher } from "helpers/fetcher";

import { TGetListOperatorReq, TGetListOperatorRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListOperator = async (payload: TGetListOperatorReq) => {
  return await fetcher<TGetListOperatorRes, TGetListOperatorReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_LIST_OPERATOR,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetListOperator = async (payload: TGetListOperatorReq) => {
  return await getListOperator(payload);
};

queryGetListOperator._key = (payload?: TGetListOperatorReq) => [
  ENDPOINT.MANAGEMENT.GET_LIST_OPERATOR.url,
  payload,
];
